module.exports = __webpack_public_path__ + "static/media/cow.40d5a643.svg";